import { put, takeLatest } from 'redux-saga/effects'
import * as actions from './slices'
import { startDomRiaImportReq, startOlxImportReq } from '../../../api/jobs'

export function* startOlxImportApi() {
  yield put(actions.setIsOlxImportSuccess(false))
  yield put(actions.setIsOlxLoading(true))
  try {
    yield startOlxImportReq()
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error)
  }
  yield put(actions.setIsOlxImportSuccess(true))
  yield put(actions.setIsOlxLoading(false))
}

export function* startDomRiaImportApi() {
  yield put(actions.setIsDomRiaImportSuccess(false))
  yield put(actions.setIsDomRiaLoading(true))
  try {
    yield startDomRiaImportReq()
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error)
  }
  yield put(actions.setIsDomRiaImportSuccess(true))
  yield put(actions.setIsDomRiaLoading(false))
}

export function* watchImportsApi() {
  yield takeLatest(actions.startOlxImport.type, startOlxImportApi)
  yield takeLatest(actions.startDomRiaImport.type, startDomRiaImportApi)
}
